import { useState } from '#app'
import { apiFetch } from '#imports'
import type { actionResponse } from '~/layers/cms/app/types/cmsTypes'
import type { Flat } from '~/types/types'

export const useGhostStuff = () => {
  const Flats = useState<Record<number, Flat>>('Flats')

  const openLink = (e: Event) => {
    const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0
    if (isTouch) {
      return
    }

    const index = Number((e.currentTarget as HTMLElement).id)
    const card_link = (Flats.value?.[index]?.card_link ?? '')
    if (!card_link) return
    window.open(card_link)
  }

  return { openLink }
}

export const getLokaleWithHistory = async (): Promise<actionResponse> => {
  const options = {
    method: 'GET'
  }

  const url = `/api/get-apartamenty-with-price-change-history`

  return apiFetch(url, options)
}

export const getLokaleWithHistoryNajem = async (): Promise<actionResponse> => {
  const options = {
    method: 'GET'
  }

  const url = `/api/get-apartamenty-with-price-change-history-najem`

  return apiFetch(url, options)
}


export const getLokaleWithHistoryDomSeniora = async (): Promise<actionResponse> => {
  const options = {
    method: 'GET'
  }

  const url = `/api/get-apartamenty-with-price-change-history-dom-seniora`

  return apiFetch(url, options)
}
